import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ShopService } from 'src/app/services/shop.service';
import { OpenDateTime } from 'src/app/models/open-date-time.model';

@Component({
  selector: 'app-time-content',
  templateUrl: './time-content.component.html',
  styleUrls: ['./time-content.component.scss']
})
export class TimeContentComponent implements OnInit, OnDestroy {

  selectedDateTime$: any;
  selectedDateTime = null;
  time: any;
  date: Date;
  openDateTimes$: any;
  openDateTimes: Array<OpenDateTime> = null;
  times: Date[] = null;
  date$: any;
  time$: any;

  @Input() type: string;
  @Input() isOpen: boolean;

  constructor(
    private shop: ShopService
  ) { }

  ngOnInit() {
    this.openDateTimes$ = this.shop.openDateTimes.subscribe(
      (o) => {
        this.openDateTimes = o;
      }
    );
    this.selectedDateTime$ = this.shop.selectedDateTime.subscribe(
      (s) => {
        this.selectedDateTime = s;
      }
    );
    this.date$ = this.shop.selectedDate.subscribe(
      (d) => {
        this.date = d;
        this.setAvailableTimes();
      }
    );
    this.time$ = this.shop.selectedTime.subscribe(
      (d) => {
        this.time = d;
      }
    );
  }

  ngOnDestroy() {
    this.selectedDateTime$.unsubscribe();
    this.openDateTimes$.unsubscribe();
    this.date$.unsubscribe();
    this.time$.unsubscribe();
  }

  onSelectDate() {
    const userTimezoneOffset = this.date.getTimezoneOffset() * 60000;
    const date = new Date(this.date.getTime() - userTimezoneOffset);
    this.shop.selectedDate.next(date);
    this.setAvailableTimes();
  }

  setAvailableTimes() {
    if (!this.date) { return; }
    // set available times
    this.times = null;
    this.openDateTimes.forEach(
      (o) => {
        if (new Date(o.date).toISOString().substring(0, 9) === this.date.toISOString().substring(0, 9)) {
          this.times = o.times;
        }
      }
    );
  }

  onSelectTime() {
    this.shop.selectedTime.next(this.time);
    const timeDate = (new Date(this.time));
    let selectedDateTime = new Date(this.date.setHours(timeDate.getHours()));
    selectedDateTime = new Date(selectedDateTime.setMinutes(timeDate.getMinutes()));
    let isoString = (selectedDateTime.toISOString());
    if (isoString.substring(isoString.length - 1) === 'Z') {
      isoString = isoString.substring(0, isoString.length - 1);
    }
    this.shop.selectedDateTime.next(isoString);
    this.closeFoldItem();
  }

  closeFoldItem() {
    this.isOpen = false;
  }

  getMinDate() {
    return new Date(this.openDateTimes[0].date);
  }

  getMaxDate() {
    return new Date(this.openDateTimes[this.openDateTimes.length - 1].date);
  }

  formatViewTime(time) {
    return time.substring(11, 16); // remove date and seconds
  }

}
